<div id="orders" class="page-layout carded fullwidth">
    <div class="top-bg primary"></div>
    <!-- CENTER -->
    <div class="center" fusePerfectScrollbar>

        <!-- HEADER -->
        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutGap="20px" fxLayoutAlign.gt-xs="space-between center">

            <!-- APP TITLE -->
            <div class="mat-display-1 my-0 my-sm-24 welcome-message" fxLayout="row" fxLayoutAlign="start center">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'ENVANTER' | translate}}</span>
            </div>
            <!-- / APP TITLE -->
            <div class="search-wrapper  ml-sm-32">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon>search</mat-icon>
                    <input #filter [(ngModel)]="filterText" placeholder="{{'SEARCH' | translate}}">
                </div>
            </div>
            <div class="row">
                <button (click)="refresh()" mat-raised-button>
                    <mat-icon>refresh</mat-icon>
                </button>
            </div>
        </div>
        <!-- / HEADER -->

        <div class="content-card my-16" style="justify-content: space-between;">
            <div class="p-20">
                <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px;" #table
                    [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}" matSortActive="startDate"
                    matSortDirection="desc" fusePerfectScrollbar>

                    <ng-container matColumnDef="id">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID'|translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let envanter">
                            {{envanter?.id!=null ? envanter.id : "---"}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'NAME'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let envanter">
                            {{envanter?.name!=null ? envanter.name : "---"}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="type">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'TYPE'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let envanter">
                            {{envanter?.type!=null ? envanter.type : '---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="icon">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'ICON'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let envanter">
                            <img class="avatar" [src]="appConfigService.apiConfig['api-url']+'envanter/'+envanter.icon" alt="">
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="latitude">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'LOCATION'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let envanter">
                            <a *ngIf="envanter.latitude" matTooltip="{{envanter.latitude+'/'+envanter.longitude}}"
                                href="javascript:void(null)" (click)="onEnvanterMap(envanter)">
                                <mat-icon>map</mat-icon>
                            </a>
                            <span *ngIf="!envanter.latitude">---</span>
                        </mat-cell>
                    </ng-container>


                    <ng-container matColumnDef="description">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'DESCRIPTION'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let envanter">
                            {{envanter?.description!=null ? envanter.description : "---"}}
                        </mat-cell>
                    </ng-container>
                    <!-- setting Column -->
                    <ng-container matColumnDef="setting">
                        <mat-header-cell *matHeaderCellDef>{{'SETTINGS'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let envanter">
                            <button mat-icon-button [matMenuTriggerFor]="menu"
                                aria-label="Example icon-button with a menu">
                                <mat-icon>settings</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="update(envanter)">
                                    <mat-icon>edit</mat-icon>
                                    <span>{{'UPDATE'|translate}}</span>
                                </button>
                                <button mat-menu-item (click)="deleteEnvanter(envanter)">
                                    <mat-icon>delete</mat-icon>
                                    <span>{{'DELETE'|translate}}</span>
                                </button>
                            </mat-menu>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let shift; columns: displayedColumns;" class="order" matRipple>
                    </mat-row>
                </mat-table>
                <mat-paginator #paginator [length]="paginator.length" [pageSize]="10" [pageSizeOptions]="[10, 50, 100]">
                </mat-paginator>
            </div>
        </div>
    </div>
    <!-- / CENTER -->
</div>